import { GridContainerFullHeight } from '@ts/storybook';
import DataGridParameterSettings from '@pages/DataBase/Parameters/DataGridParameterSettings';
import { useAppDispatch, useAppSelector } from '@redux/store';
import { CParameter } from '@ts/ui-models';
import { useEffect, useState } from 'react';
import { getParameters } from '@services/DataBase/Parameter.service';

const AppSettings = props => {
  const dispatch = useAppDispatch();
  const badge = useAppSelector(state => state.global.sessionBadge);
  const [listParameters, setListParameters] = useState<CParameter[]>([]);

  useEffect(() => {
    const loadParameters = async () => {
      if (!badge) return;
      const p = await getParameters(dispatch, 'app', null, badge);
      if (!p) return;
      setListParameters(p);
    };
    loadParameters();
  }, []);
  return (
    <GridContainerFullHeight p={2}>
      <DataGridParameterSettings {...props} type="app" listParameters={listParameters} />
    </GridContainerFullHeight>
  );
};
export default AppSettings;
